export default __webpack_public_path__ + "static/media/E-WEB-Goal-15.8458faf6.png";